<template>
	<div>
		<header class="header">
			<div class="left">
				<span @click="handlerAddClick('add')" class="span1">添加机构子账号</span>
				<div class="btns" @click="handlerBulkImportClick">
					批量导入
				</div>
                <!-- 只有管理员有权限配置 -->
				<div class="btns" style="margin-left: 16px" @click="approvalConfiguration">
					审批配置
				</div>

			</div>
			<div class="center">
				<p class="p1" @click="handlerSwithClick(item)" :class="current.name === item.name ? 'active' : ''"
					v-for="(item, keys) in switchDats" :key="keys">
					{{ item.name }}
				</p>
			</div>
			<div class="right">
				<input class="input1" placeholder="输入昵称/手机号" type="text">
				<div style="position: relative;">
					<div class="btns1" @click="flag = !flag">
						选择
					</div>
					<div v-if="flag" class="zhedie">
						<!-- <p v-if="current.name === '正常状态'" style="margin-bottom: 0.12rem;"> 批量发送登陆信息</p> -->
						<p @click="handlerStateClick(current.title)">{{ current.title }}</p>
					</div>
				</div>
			</div>
		</header>
		<div class="container2" v-loading="loading">
			<main class="main">
				<div class="mainBox" v-for="(item) in viewDatas" :key="item.id">
					<div v-if="flag" class="selectBtns">
						<img @click="selsect(item)"
							:src="selectDatas.findIndex(n => n.id == item.id) !== -1 ? require('../../assets/png/acitveBtn.png') : require('../../assets/png/nacActive.png')"
							alt="">
					</div>
					<div class="btn" :class="current.name === '正常状态' ? 'active2' : 'active1'">
						普通用户
					</div>
					<div class="left">
						<img class="imgs" style="margin-bottom: 0.12rem;"
							:src="item.imageUrl ? item.imageUrl : require('../../assets/png/touxian.jpeg')">
						<!-- <el-button v-if="item.status != 2" size="medium" class="btn1" plain>发送登录信息</el-button> -->
						<span class="span1">{{ item.createTime }}  生成</span>
					</div>
					<div class="center">
						<p>{{ item.userName }}</p>
						<p>登录手机：{{ item.loginAccount }} <span class="span1"
								@click="handlerAddClick('update', item)">编辑</span> </p>
						<p>邮箱地址：{{ item.email ? item.email : '无' }} <span class="span1"
								@click="handlerAddClick('update', item)">编辑</span>
						</p>
						<p>支付状态：不可用公司账户支付
							<span class="span1" @click="handlerAddClick('update', item)">编辑</span>
						</p>
						<p style="display: flex;">接单区域：
							<span v-if="item.platSupplierAreas.length > 0" style="border-bottom: 1px solid #CCCCCC;width: 2.3rem;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
								<span v-for="(n, m) in item.platSupplierAreas" :key="m" class="span2"
									@click="handlerAddClick('update', item)">{{ n.nameCn }}
								</span>
							</span>
							<span style="font-size: 20px;font-weight: bold;" class="span1"
								@click="handlerAddClick('status', item)">{{ item.status == 1 ? '停用' : '恢复' }}</span>
						</p>
					</div>
				</div>
			</main>
			<footer style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;">
					<p style="color:gray;font-size: 0.12rem;margin-top: 15px;">共{{ total }}位{{ current.name }}的员工账号</p>
					<el-pagination :page-size="6" @current-change="qhPages" background layout="prev, pager, next"
						:total="total">
						<!-- prev-text="上一页" next-text="下一页" -->
					</el-pagination>
				</div>
			</footer>
		</div>
		<addAccount @updateStatue="updateStatue" @update="update" ref="addAccount"></addAccount>
		<bulkImportPopopVue ref="bulkImportPopopVue"></bulkImportPopopVue>
		<buIkImportStatePopupVue @updateStatue="updateStatue" ref="buIkImportStatePopupVue"></buIkImportStatePopupVue>
		<ApplyProject ref="applyProject"></ApplyProject>
	</div>
</template>

<script>
import bulkImportPopopVue from './components/institutionalTeamChild/bulkImportPopop.vue'
import addAccount from './components/institutionalTeamChild/addAccount.vue'
import buIkImportStatePopupVue from './components/institutionalTeamChild/buIkImportStatePopup.vue'
import ApplyProject from "@/views/mechanism/children/ApplyProject.vue";
import Api from "@/components/Api/index";
export default {
	components: {
		addAccount,
		bulkImportPopopVue,
		buIkImportStatePopupVue,
		ApplyProject
	},
	data() {
		return {
			loading: true,
			page: 1,
			status: 1,//用户状态
			flag: false,
			total: 0,
			viewDatas: [],//渲染的数据
			selectDatas: [],//选择需要操作的数据
			current: {
				title: '批量停用',
				name: '正常状态',
				keys: '1',
				text: '确认批量停用上述员工账号',
			},
			switchDats: {
				'0': {
					title: '批量停用',
					name: '正常状态',
					keys: 1,
					text: '确认批量停用上述员工账号',
				},
				'1': {
					title: '批量恢复',
					name: '停用状态',
					keys: 2,
					text: '确认批量恢复上述员工账号',
				}
			}
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		approvalConfiguration() {
			this.$refs.applyProject.init();
		},
		//更新列表
		update() {
			this.getData()
		},
		//更新子账户状态
		updateStatue(val) {
			this.selectDatas = []
			this.flag = false
			this.handlerSwithClick(val)
		},
		//选择
		selsect(item) {
			if (this.selectDatas.findIndex(n => n.id === item.id) === -1) {
				this.selectDatas.push(item)
			} else {
				this.selectDatas = this.selectDatas.filter(n => n.id !== item.id)
			}
			console.log(this.selectDatas, '是大撒打算大');
		},
		//获取用户列表数据
		getData() {
			this.loading = true
			let data = {
				"page": this.page,
				"q": {
					"applets": "",
					"clientId": "",
					"createTime": "",
					"desPassword": "",
					"email": "",
					"id": 0,
					"imageKey": "",
					"imageUrl": "",
					"isAllArea": 0,
					"isFirstAccount": 0,
					"isReceivingOrders": 0,
					"loginAccount": "",
					"loginPassword": "",
					"mechanismId": 0,
					"mechanismName": "",
					"officialAccount": "",
					"roleIds": [],
					"status": this.status,
					"supplierColor": "",
					"supplierKey": "",
					"userName": ""
				},
				"size": 6
			}
			new Api("user")
				.userList(data)
				.then((res) => {
					if (res.status == 200) {
						this.viewDatas = res.data.records
						this.total = res.data.total
						console.log(this.viewDatas, '大撒打算弟弟');
						this.viewDatas.forEach(item => {
							this.$set(item, 'isPay', item.isPay == 0 ? false : true)
						})
						this.loading = false
					} else {
						this.$message.error(res.statusText);
						this.loading = false
					}
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "系统异常!",
					});
				});
		},
		//切换页数
		qhPages(val) {
			this.page = val
			this.getData()
		},
		handlerSwithClick(item) {
			console.log(item, '看见阿萨德计算机');
			this.current = item
			this.status = item.keys
			this.getData()
		},
		handlerAddClick(type, item) {
			if (type === 'add') {
				let obj = {
					"applets": "",
					"clientId": "",
					"createTime": "",
					"desPassword": "",
					"email": "",
					"id": null,
					"imageKey": "",
					"imageUrl": "",
					"isAllArea": null,
					"isFirstAccount": null,
					"isPay": 0,//0 关 1开
					"loginAccount": "",
					"loginPassword": "",
					"mechanismId": 0,
					"mechanismName": "",
					"officialAccount": "",
					"platSupplierAreas": [],
					"roleIds": [],
					"status": 1,
					"supplierColor": "",
					"supplierKey": "",
					"userName": ""
				}
				this.$refs.addAccount.init(obj)
			} else if (type === 'update') {
				this.$refs.addAccount.init(item)
			} else {
				this.$refs.addAccount.init(item, this.current)
			}
		},
		//批量导入
		handlerBulkImportClick() {
			this.$refs.bulkImportPopopVue.init()
		},
		//恢复或停用
		handlerStateClick() {
			if (this.selectDatas.length == 0) {
				this.$message({
					type: "warning",
					message: "请选择数据进行维护",
				});
			} else {
				this.$refs.buIkImportStatePopupVue.init(this.current, this.selectDatas)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.active {
	color: rgba(43, 43, 47, 1);
	font-size: 0.24rem !important;
	font-weight: bold;
	font-family: SourceHanSansSC-bold;
}

.active1 {
	background-color: #646464 !important;
}

.active2 {
	background-color: rgba(236, 195, 119, 1);
}

.header {
	width: 16.5rem;
	height: 0.6rem;
	padding: 0 0.8rem;
	margin-left: 8px;
	background: white;
	border-radius: 10px;
	display: flex;
	align-items: center;

	.left {
		display: flex;
		align-items: center;
		flex: 1;

		.span1 {
			color: rgba(58, 98, 215, 1);
			font-size: 0.22rem;
			font-family: SourceHanSansSC-bold;
			border-bottom: 1px solid rgba(58, 98, 215, 1);
			margin-right: 0.24rem;
			cursor: pointer;
		}

		.btns {
			width: 0.8rem;
			height: 0.25rem;
			border-radius: 0.04rem;
			background-color: rgba(58, 98, 215, 0.25);
			color: rgba(58, 98, 215, 1);
			font-size: 0.14rem;
			text-align: center;
			font-family: PingFang SC;
			line-height: 0.25rem;
			cursor: pointer;
		}
	}

	.center {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;

		.p1 {
			color: rgba(36, 53, 69, 1);
			font-size: 0.20rem;
			margin-bottom: 0;
			font-family: SourceHanSansSC-regular;
			margin-right: 0.24rem;
			cursor: pointer;

			&:nth-last-child(1) {
				margin-right: 0;
			}
		}

	}

	.right {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		.input1 {
			width: 2.3rem;
			height: 0.44rem;
			border-radius: 0.25rem;
			background-color: rgba(235, 235, 235, 0.71);
			color: rgba(16, 16, 16, 1);
			font-size: 0.14rem;
			text-align: center;
			outline: none;
			border: none;
			font-family: Roboto;
			margin-right: 0.24rem;
		}

		.btns1 {
			width: 0.7rem;
			height: 0.25rem;
			border-radius: 0.04rem;
			background-color: rgba(58, 98, 215, 0.25);
			color: rgba(58, 98, 215, 1);
			font-size: 0.14rem;
			text-align: center;
			font-family: PingFang SC;
			line-height: 0.25rem;
			cursor: pointer;

		}

		.zhedie {
			position: absolute;
			left: 0;
			top: 0.3rem;
			color: #fff;

			p {
				background-color: #4E8FF1;
				cursor: pointer;
				text-align: center;
			}
		}
	}
}

.container2 {
	padding: 0.5rem 1.5rem;
	min-height: 8rem;

	.main {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		.mainBox {
			width: 5.78rem;
			min-height: 2.35rem;
			border-radius: 0.25rem;
			padding: 0.4rem 0.14rem 0.24rem 0.4rem;
			position: relative;
			background-color: rgba(255, 255, 255, 1);
			display: flex;
			margin-bottom: 0.24rem;

			.selectBtns {
				position: absolute;
				top: 0.2rem;
				left: 0.2rem;

				img {
					width: 0.25rem;
					cursor: pointer;
				}
			}

			.btn {
				width: 1.42rem;
				height: 0.62rem;
				border-radius: 0 0.25rem 0 0.25rem;
				background-color: rgba(236, 195, 119, 1);
				color: rgba(16, 16, 16, 1);
				text-align: center;
				line-height: 0.62rem;
				color: rgba(255, 255, 255, 1);
				font-size: 0.2rem;
				font-family: SourceHanSansSC-regular;
				position: absolute;
				top: 0;
				right: 0;
			}

			.left {
				width: 1.3rem;
				display: flex;
				align-items: center;
				flex-direction: column;
				margin-right: 0.2rem;

				.imgs {
					width: 84px;
					height: 72px;
				}

				.btn1 {
					border-radius: 0.04rem;
					background-color: rgba(58, 98, 215, 0.52);
					color: rgba(255, 255, 255, 1);
					border: none;
					font-size: 0.14rem;
					text-align: center;
					font-family: PingFang SC;
					margin-bottom: 0.2rem;
				}

				.span1 {
					color: rgba(113, 107, 109, 1);
					font-size: 0.12rem;
					font-family: SourceHanSansSC-regular;
					text-decoration:underline;
					// border-bottom: 1px solid rgba(113, 107, 109, 1);

				}
			}

			.center {
				flex: 1;

				p {
					color: rgba(102, 102, 102, 1);
					font-size: 0.16rem;
					font-family: SourceHanSansSC-regular;
					margin-bottom: 0.1rem;
					display: flex;
					justify-content: space-between;
				}

				.span1 {
					color: rgba(50, 189, 254, 0.91);
					font-size: 0.16rem;
					font-family: SourceHanSansSC-regular;
					cursor: pointer;
				}

				.span2 {
					cursor: pointer;
					margin-right: 6px;

					&:nth-last-child(1) {
						margin-right: 0;
					}
				}
			}

			.footer {
				display: flex;
				align-items: center;
				background-color: red;

			}
		}
	}
}</style>
